import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const CloseButtonCss = css`
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  background-color: black;
  width: 20px;
  height: 20px;
  align-items: center;
  justify-content: center;

  &:hover,
  &:focus {
    background-color: black;
    transform: scale(1.1, 1.1);
    transition: all 0.1s ease;
  }
`

export const RelativeWrapper = styled.div`
  position: relative;
`

export const Tooltip = styled.span`
  position: absolute;
  right: 58px;
  width: max-content;
  max-width: 200px;
  text-align: center;
  padding: 0.5em;
  border-radius: 5px;
  background-color: white;
  z-index: 1;
  box-shadow: 1px 0px 4px 0px rgba(0, 0, 0, 0.2);

  &::after {
    top: calc(50% - 5px);
    left: 100%;
    border-color: transparent transparent transparent white;
  }

  &::after {
    content: '';
    position: absolute;
    border-width: 5px;
    border-style: solid;
  }
`
